import axios from "axios";

export const fetchCreateTaskCounterTemplate = async (body: any) => {
  const baseTaskUrl = process.env.REACT_APP_TASK_API_URL;
  return await axios.post(`${baseTaskUrl}/TaskCounterTemplate`, body);
};
